@import '../../../theme.scss';

verdocs-send {
  padding: 10px;
  position: relative;
  background: #ffffff;
  flex-direction: column;
  font-family: $verdocs-primary-font;

  &.sendable {
    display: flex;
  }

  .recipients {
    position: relative;
  }

  // To avoid the need to compute things like heights, this layer is simply displayed "on top" of all the level rows. Its
  // background obscures the horizontal lines.
  .left-line {
    top: 32px;
    left: 20px;
    z-index: 1;
    width: 12px;
    bottom: 30px;
    position: absolute;
    background: #ffffff;
    border-left: 3px dotted #9b9b9b;
  }

  .level {
    display: flex;
    column-gap: 10px;
    margin-left: 50px;
    position: relative;
    flex-direction: row;
    padding: 8px 0 4px 0;
    border-bottom: 1px solid #97979744;

    .level-icon {
      top: 14px;
      z-index: 2;
      left: -40px;
      width: 24px;
      height: 24px;
      position: absolute;
      background: #ffffff;

      svg {
        fill: #00000089;
      }
    }

    .recipient {
      height: 30px;
      display: flex;
      flex: 0 0 30px;
      color: #000000;
      cursor: pointer;
      font-size: 14px;
      align-items: center;
      border-radius: 30px;
      flex-direction: row;
      background: #dddddd;
      white-space: nowrap;
      border: 2px solid #dddddd;
      padding: 2px 10px 2px 14px;

      .icon {
        width: 22px;
        height: 22px;
        flex: 0 0 22px;
        margin: 0 0 0 10px;

        svg {
          width: 22px;
          height: 22px;
          fill: #333333;
          outline: none;
        }
      }
    }

    .complete {
      flex: 1;
      height: 30px;
      display: flex;
      color: #000000;
      font-size: 14px;
      align-items: center;
      flex-direction: row;
      padding: 3px 10px 3px 2px;
    }
  }

  .buttons {
    display: flex;
    margin-top: 10px;
    column-gap: 15px;
    flex-wrap: wrap;
    flex-direction: row;
    align-items: center;

    .error-message {
      width: 100%;
      color: #cc0000;
      font-size: 13px;
      margin-bottom: 10px;
    }
  }

  verdocs-contact-picker {
    left: 0;
    top: 41px;
    z-index: 10;
    position: absolute;
    border: 1px solid #dddddd;
    box-shadow: 0 0 6px 3px rgb(0 0 0 / 10%);
  }
}
